import { InjectionToken } from '@angular/core';

/**
 * O app está sobre dados de exemplo.
 *
 * Toda tela que mostra dado da feira leva a tarja de demonstração quando isto
 * é verdadeiro. Hoje é o caso de todas: a API ainda não tem leitura pública
 * (NEXPO-API-09). Quando uma tela passar a ler de verdade, ela perde a tarja
 * no mesmo PR — por tela, não pelo app.
 */
export const VISITOR_DEMO_MODE = new InjectionToken<boolean>('VISITOR_DEMO_MODE', {
	providedIn: 'root',
	factory: () => false,
});
